import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Drawer,
    Icon,
    Form,
    Input,
    DatePicker,
    notification,
    Select
} from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;
const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerConceito = ({ notaId, visible, onClose, atualizar, form }) => {
    const [classificacoes, setClassificacoes] = useState([]);
    const [data, setData] = useState(null);
    const [nota, setNota] = useState(undefined);
    const [observacoes, setObservacoes] = useState("");
    const [iconLoading, setIconLoading] = useState(false)

    const { getFieldDecorator } = form;

    //const detalhe = () => {

    //}

    const info = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/conceitos-classificacoes",
            params: {
                estruturaId: JSON.parse(localStorage.getItem("aproveitamento")).estrutura
            }
        })
            .then(response => {
                setClassificacoes(response.data.map(x => x.nome));
            })
            .catch(error => {
            });
    }

    const alterar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err && (data || nota || observacoes)) {
                setIconLoading(true);

                var item = new FormData();
                item.append("id", notaId);
                if (data)
                    item.append("data", moment(data).format("YYYY/MM/DD"));
                if (nota)
                    item.append("nota_texto", nota);
                if (observacoes)
                    item.append("observacoes", observacoes);

                axios({
                    method: "put",
                    url: "/api/aproveitamento/alterar-conceito",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Registo alterado");
                        setIconLoading(false);
                        atualizar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        setIconLoading(false);
                    });
            }
            else {
                if (!data || !nota || !observacoes)
                    openNotificationWithIcon("error", "Erro", "Não existem dados para guardar.");
            }
        })
    }

    const afterVisibleChange = aberto => {
        if (!aberto) {
            form.resetFields();
            setData(null);
            setNota(undefined);
            setObservacoes("");
        }
        else {
            info();
        }
    }

    //useEffect(() => {
    //    form.resetFields();

    //    if (notaId > 0)
    //        detalhe();

    //}, [notaId]);

    return (
        <Drawer
            className="drawer-add-cursos"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias listagem-avaliacoes" layout="horizontal">
                    <div className="bloco">
                        <Form.Item label="Data">
                            {getFieldDecorator("data", {
                                initialValue: data
                            })(<DatePicker
                                placeholder="Selecionar"
                                format="DD/MM/YYYY"
                                onChange={(date) => setData(date)}
                            />
                            )}
                        </Form.Item>
                        <Form.Item label="Nota">
                            {getFieldDecorator("nota", {
                                initialValue: nota
                            })(
                                <Select placeholder="Selecionar" onChange={nota => setNota(nota)}>
                                    {classificacoes.map((classificacao, index) => (
                                        <Option key={index} value={classificacao}>{classificacao}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Observações">
                            {getFieldDecorator("observacoes", {
                                initialValue: observacoes
                            })(<TextArea name="observacoes" onChange={(e) => setObservacoes(e.target.value)} rows={4} style={{ height: 100 }} />)}
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>
                <button className="botao-principal" onClick={alterar} disabled={iconLoading} type="primary">
                    {iconLoading ? <Icon type="loading" /> : null}
                    Salvar
                </button>
            </div>
        </Drawer>
    );
}

const FormDrawerConceito = Form.create({ name: "drawer-conceito" })(DrawerConceito);

export default FormDrawerConceito;